import React from "react";
import { string, oneOfType, number, objectOf, object, shape, array, arrayOf } from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../sharedComponents/Card";
import { List } from "../../List";
// eslint-disable-next-line import/no-cycle
import { Button } from "../../Button";
import * as styles from "./QuaternaryCard.module.scss";

const QuaternaryCard = ({
	image,
	header,
	subheader,
	content,
	checklist,
	link,
	className,
	style,
}) => (
	<Card className={cx(styles.quaternary, className)} style={style}>
		<Card.Image
			className={cx(styles.image)}
			src={!image.srcSet && image.src}
			source={image.srcSet && image}
			alt={image.alt}
			fluid={image.fluid}
			clickable={link}
		/>
		<Card.BodyContainer className={cx(styles.contentContainer)}>
			<Card.Header className={cx(styles.heading)}>{header}</Card.Header>
			{subheader && <Card.Subheader>{subheader}</Card.Subheader>}
			{checklist ? (
				<Card.Content className={cx(styles.checklist)}>
					<List theme="checklist" data={checklist}>
						{checklist.map(cl => (
							<List.Item key={cl.id}>{cl.item}</List.Item>
						))}
					</List>
				</Card.Content>
			) : (
				<Card.Content>{content}</Card.Content>
			)}
			{link?.to && <Button to={link.to} label={link.text} />}
		</Card.BodyContainer>
	</Card>
);

QuaternaryCard.propTypes = {
	image: shape({
		fluid: oneOfType([object, array]),
		fixed: oneOfType([object, array]),
		source: shape({
			src: string,
			srcSet: string,
			sizes: string,
		}),
		alt: string,
		src: string,
	}).isRequired,
	header: string.isRequired,
	subheader: string,
	content: string,
	checklist: arrayOf(object),
	link: shape({
		to: string.isRequired,
		target: string,
		icon: shape({
			svg: shape({
				content: string,
			}),
		}),
		text: string,
	}),
	className: string,
	style: objectOf(oneOfType([string, number])),
};

QuaternaryCard.defaultProps = {
	subheader: "",
	content: "",
	checklist: [],
	link: null,
	className: "",
	style: {},
};

export default QuaternaryCard;
export { QuaternaryCard };
